import { render, staticRenderFns } from "./jump1.vue?vue&type=template&id=3450140c&scoped=true"
import script from "./jump1.vue?vue&type=script&lang=js"
export * from "./jump1.vue?vue&type=script&lang=js"
import style0 from "./jump1.vue?vue&type=style&index=0&id=3450140c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450140c",
  null
  
)

export default component.exports